import { clsx } from 'clsx';
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export function Card({ children, className, selected, onClick, disabled }: CardProps) {
  const isClickable = onClick && !disabled;

  return (
    <div
      className={clsx(
        'rounded-lg border bg-white p-4 shadow-sm transition-all',
        selected && 'border-hermit-500 ring-2 ring-hermit-200',
        !selected && 'border-gray-200',
        isClickable && 'cursor-pointer hover:border-hermit-300 hover:shadow-md',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
      onClick={isClickable ? onClick : undefined}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

export function CardHeader({ children, className }: CardHeaderProps) {
  return (
    <div className={clsx('mb-3 border-b border-gray-100 pb-3', className)}>
      {children}
    </div>
  );
}

interface CardTitleProps {
  children: ReactNode;
  className?: string;
}

export function CardTitle({ children, className }: CardTitleProps) {
  return (
    <h3 className={clsx('text-lg font-semibold text-gray-900', className)}>
      {children}
    </h3>
  );
}

interface CardDescriptionProps {
  children: ReactNode;
  className?: string;
}

export function CardDescription({ children, className }: CardDescriptionProps) {
  return (
    <p className={clsx('text-sm text-gray-500', className)}>{children}</p>
  );
}

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

export function CardContent({ children, className }: CardContentProps) {
  return <div className={className}>{children}</div>;
}
